<template>
  <div class='login-container' :style="{backgroundImage: 'url(/static/image/login/login.png)'}">
    <el-form ref="loginUser" :model="loginUser" class="login-form" label-position="left" >
      <el-input  v-model="loginUser.account" placeholder="请输入账号" prefix-icon="el-icon-user-solid" ></el-input>
      <el-input type="password" v-model="loginUser.password" placeholder="请输入密码" prefix-icon="el-icon-s-goods" suffix-icon="el-icon-view" ></el-input>
      <el-button @click="login">登录</el-button>
    </el-form>
  </div>
</template>
<script>
import {globalVariable, dict} from '../../api/sys/dict.js'
import {GLOBAL_URL, set_global_states, set_dict} from '../../config/config.js'
import {logout} from '../../api/sys/login.js'
export default {
  name: "Login",
  data() {
    return {
      isBtnLoading: false,
      checked: true,
      dlProgress: 0,
      loginUser: {
        account: "",
        password: "",
      }
    };
  },
  methods: {

    /**
     * 登录
     */
    login() {
      if (this.loginUser != null) {
        this.$store.dispatch('user/login',this.loginUser).then( () => {
        })
      }
    },

    /**
     * 获取全局数据
     */
    getDict(){
    //获取申请状态
      dict().then( ({data}) => {
        set_dict(data)
      })
    },
    getGlobalVariable(){
    //获取全局状态类型
      globalVariable().then( ({data}) =>{
        set_global_states(data)
      })
    },
    /**
     * 退出
     */
    out() {
      logout();
      this.$router.push({ path: "/" })
    },

    /**
     * 回车键登录
     */
    enterLogin(e){
      var key = window.event ? e.keyCode : e.which
      if(key == '13'){
        this.login()
      }
    }

  },

  mounted() {
    document.addEventListener('keydown', this.enterLogin);
  },

  created() {
    this.getDict()
    this.getGlobalVariable()
  },

destroyed() {
  window.removeEventListener('keydown',this.enterLogin,false)
  }
}

</script>

<style scoped>
  @font-face {
    font-family: "loginFont";
    src: url("../../../static/font/loginFont.ttf");
  }
  .login-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size:100% 100%;
    position: absolute;
    z-index: 4;
  }
  .login-form {
      border: 1px solid white;
      border-radius: 10px;
      padding: 40px;
      /* position: relative; */
      width: 400px;
      max-width: 100%;
      margin: 17% 60%;
      overflow: hidden;
      z-index: 2;
    }
  .el-button{
      width: 100%;
      margin-top: 10px;
      background-color: #D8D8D8;
    }
  /deep/ .el-input--prefix .el-input__inner {
    margin: 20px 0;
    background: transparent;
    color: #ffffff;
  }

  button:hover {
    cursor: pointer;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue